import BottomLogo from '../../assets/images/bottomlogo.png';
import HouseLogo from '../../assets/images/svg/houselogo.svg';

const CommonPorblems = (props) => {
    return (
        <div>
            <div className='bg-light common-problems' key={'commonProblem'}>
                <div className='container'>
                    <div className='content-wrapper'>
                        <div className='text-content'>
                            <h2 className='title hero-blue'>{props.title}</h2>
                            <p className='text-normal-12 lightGrey ' style={{ whiteSpace: 'pre-line' }}>{props.description}</p>
                            {props.suitability && props.rentingTypes && props.rentingTypes.length > 0 ? (
                                <div className='rental-options-section'>
                                    <h2 className='rental-options-title'>{props.suitability}</h2>
                                    <div className='rental-options-grid'>
                                        {props.rentingTypes.map((rentingType, idx) => (
                                            <div key={`renting-type-${idx}`} className='rental-option'>
                                                <div className='rental-option-icon'>
                                                    <img src={HouseLogo} alt="" aria-hidden="true" />
                                                </div>
                                                <span className='rental-option-text'>{rentingType}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className='main-imagecontainer'>
                        <div className='image-content'>
                            <img src={BottomLogo} alt="" aria-hidden="true" />
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CommonPorblems
